import { put, takeEvery, select } from 'redux-saga/effects'
import * as savePointActions from '../SavePoint/savePoint.actions'
import { Game } from '../../Core'

import DataConsumeWarning from './'

/**
 *  Components module initialization.
 */
function* init() {
  yield loadComponents()
}

/**
 *  sync savepoint.
 */
function* syncSavePoint() {
  const game = yield select(Game.selectors.getGame)

  yield put(savePointActions.syncWithGame(game))
  yield put(savePointActions.startSave())
}
/**
 * Load components.
 */
export function* loadComponents() {
  const components = {
    DataConsumeWarning,
  }

  yield put(Game.actions.registerComponents(components))
}

/**
 * Sagas entrypoint.
 */
export function* sagas() {
  yield init()
  yield takeEvery(Game.actions.TOGGLE_CONSUME_WARNING, syncSavePoint)
}
